import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Skeleton } from '@mui/material';

import MapAIML from '../components/dashboard/MapAIML';
import DataPanel from '../components/dashboard/DataPanel';
import { getAreaMaster, getAreaCurrent } from '../services/area';
import { getStationCurrent } from '../services/station';
import PDPAModalComponent from '../components/PDPAModalComponent';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      areaMaster: [],
      currentStation: [],
      currentArea: [],
      filter: {
        province: "เชียงใหม่",
        amphoe: null,
        tambon: null,
        dwr_region: null,
        dopa_region: null,},
    }
  }

  componentDidMount() {
    this.initData()
  }

  // componentDidUpdate() {
  //   // console.log('update ')
  //   this.initData()
  //   console.log('update state', this.state)
  // }

  async initData() {
    // let areaMaster = await getAreaMaster()
    // let currentStation = await getStationCurrent()
    // let currentArea = await getAreaCurrent()
    // console.log(this.state.filter)
    // let province = this.state.filter.province
    // let amphoe = this.state.filter.amphoe
    // let tambon = this.state.filter.tambon
    let areaMaster = null
    let currentStation = null
    let currentArea = null
    let _master = window.localStorage.getItem('master')
    if (_master !== null) {
      _master = JSON.parse(_master)
      let currentTime = new Date()
      let dataTime = new Date(_master['timestamp'])
      let diff = currentTime - dataTime
      let threshold = 1*60*60*1000 // 1 Hours
      if (diff <= threshold) {
        areaMaster = _master['areaMaster']
        currentStation = _master['currentStation']
        currentArea = _master['currentArea']
      }
    }

    if (areaMaster === null || currentStation === null || currentArea == null ) {
      let result = await Promise.all([
        getAreaMaster(), 
        getStationCurrent(), 
        getAreaCurrent(),
      ])
      areaMaster = result[0]
      currentStation = result[1]
      currentArea = result[2]

      let master = {
        'timestamp': new Date(),
        'areaMaster': areaMaster,
        'currentStation': currentStation,
        'currentArea': currentArea
      }
      window.localStorage.setItem('master', JSON.stringify(master))
    }

    await this.setState({
      areaMaster,
      currentStation,
      currentArea
    })
  }

  onFilterChange = async (value, event) => {
    await this.setState({
      filter: value
    })
    await this.initData()
  }

  render() {
    return (
      <Box sx={{display: 'grid', height: '100%', 	minHeight: 800}}>
        <PDPAModalComponent/>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4} sx={{minHeight: 400}}>
            {this.state.currentStation.length>0
              ? <MapAIML 
                areaData={this.state.currentArea}
                stations={this.state.currentStation}
                filter={this.state.filter}
              />
              : <Skeleton  variant='rectangle' sx={{m: 3, minHeight: 800}}></Skeleton>
            }
          </Grid>
          <Grid item xs={12} md={8} sx={{minHeight: 400}}>
            <Grid item>
              {this.state.currentStation.length>0
                ? <DataPanel 
                  area={this.state.areaMaster}
                  current={this.state.currentStation}
                  filter={this.state.filter}
                  onFilterChange={this.onFilterChange}
                />
                : <Box alignItems="center" justifyContent="center" sx={{minHeight: 800 , mt: 10, mb: 10}}>
                  <Skeleton width={'80%'}></Skeleton>
                  <Skeleton width={'80%'}></Skeleton>
                  <Skeleton width={'80%'}></Skeleton>
                  <Skeleton width={'80%'} variant='rectangle' sx={{ minHeight: 400}}></Skeleton>
                </Box>
              }
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default Dashboard;
